import React from 'react';

const FieldMessage = (props) => {
  const { name, className, register, validation, defaultValue, options } = props;
  return <div />;
};

export default FieldMessage;
